/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, real, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const notificationDeliveries = sqliteTable('notification_deliveries', {
  id: text('id').primaryKey().notNull(),
  notification_job_id: text('notification_job_id'),
  org_id: text('org_id'),
  channel: text('channel'),
  provider_name: text('provider_name'),
  attempt: integer('attempt'),
  status: text('status'),
  provider_message_id: text('provider_message_id'),
  provider_status: text('provider_status'),
  error_code: text('error_code'),
  error_message: text('error_message'),
  estimated_billable: integer('estimated_billable'),
  estimated_price_amount: real('estimated_price_amount'),
  estimated_price_currency: text('estimated_price_currency'),
  pricing_category: text('pricing_category'),
  pricing_market: text('pricing_market'),
  pricing_basis: text('pricing_basis'),
  template_category: text('template_category'),
  created_at: text('created_at'),
});
